import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { ManufacturersState, ManufacturersType } from './types';

const getState = (state: State): ManufacturersState => state.manufacturer.manufacturers;

const getManufacturers = (state: State): RemoteRecord<ManufacturersType> => new RemoteRecord(getState(state));

export {
  getManufacturers,
  getState,
};
